import $ from 'jquery';
import dom from '../../utils/dom';

const categoryAttributeName = 'data-tn-category';

/**
 * @param {HTMLElement} $el
 * @param {string} category
 */
function setCategoryAttribute($el, category) {
  $el.setAttribute(categoryAttributeName, category);
}

/**
 * @param {string} message
 * @param {boolean} focus
 * @param {string} category
 * @param {HTMLElement} [$container]
 */
function addAlert(message, focus = false, category = null, $container) {
  const $el = dom.makeElement('div', { 'data-tn-name': 'tn-alert-message', class: 'alert alert-info tn-heading-info', role: 'status' });

  if (category) {
    setCategoryAttribute($el, category);
  }

  if ($container) {
    $container.appendChild($el);
  } else {
    const $target = dom.find('#tn-alert-message-template');

    dom.appendAfter($target, $el);
  }

  setTimeout(() => {
    $el.innerHTML = message;
  }, 100);

  $($el).show(100);

  if (focus) {
    focusUserOnMessages();
  }
}

function populateServerAlerts() {
  const $templates = dom.findAll('template[data-tn-deferred-message]');

  $templates.forEach(($template) => {
    const $liveRegion = $template.parentElement;

    setTimeout(() => {
      $liveRegion.appendChild($template.content.cloneNode(true));
      $template.remove();
    }, 100);
  });
}

/**
 * @param {string} message
 * @param {boolean} focus
 * @param {string} category
 * @param {HTMLElement} [$container]
 */
function addError(errorMessage, focus = false, category = null, $container) {
  const $el = dom.makeElement('div', { 'data-tn-name': 'tn-error-message', class: 'alert-danger alert tn-heading-error', role: 'alert' });

  if (category) {
    setCategoryAttribute($el, category);
  }

  $el.innerHTML = errorMessage;

  if ($container) {
    $container.appendChild($el);
  } else {
    const $target = dom.find('#tn-error-message-template');

    dom.appendAfter($target, $el);
  }

  $($el).show(100);

  if (focus) {
    focusUserOnMessages();
  }
}

/**
 * @param {HTMLElement[]} $els
 * @param {string} category
 */
function filterCategory($els, category) {
  return $els.filter(($el) => $el.getAttribute(categoryAttributeName) === category);
}

/**
 * @param {string} category
 */
function getAlertMessages(category = null) {
  const $els = dom.findAll('[data-tn-name=\'tn-alert-message\']');

  if (category) {
    return filterCategory($els, category);
  }

  return $els;
}

/**
 * @param {string} category
 */
function getErrorMessages(category = null) {
  const $els = dom.findAll('[data-tn-name=\'tn-error-message\']');

  if (category) {
    return filterCategory($els, category);
  }

  return $els;
}

function removeMessages(messages) {
  const $els = $(messages);

  $els.hide(100, () => {
    $els.remove();
  });
}

/**
 * @param {string} category
 */
function clearAlerts(category = null) {
  removeMessages(getAlertMessages(category));
}

/**
 * @param {string} category
 */
function clearErrors(category = null) {
  removeMessages(getErrorMessages(category));
}

/**
 * @param {string} category
 */
function clear(category = null) {
  clearAlerts(category);
  clearErrors(category);
}

function focusUserOnMessages() {
  const $el = $('#tn-error-message-template');
  const scrollTop = `${$el.offset().top - 10}px`;

  $('html, body').animate({ scrollTop }, 'fast');
}

/**
 * @param {string} category
 */
function testHasErrorMessages(category = null) {
  return getErrorMessages(category).length > 0;
}

export default {
  addAlert,
  addError,
  clearAlerts,
  clearErrors,
  focusUserOnMessages,
  populateServerAlerts,
  testHasErrorMessages,
  clear,
};
